import {
  AfterViewInit,
  Component,
  Directive,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';

import {environment} from '../../../../../environments/environment';
import {language} from '../../../../language/vn';
import {CommandUtil} from '../../../../global/commandutil';
import {DatePipe} from '@angular/common';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {BsModalService} from 'ngx-bootstrap/modal';
import { TongHopYKienYeuCauComponent} from './tonghop.component';
import { FileYeuCauComponent} from './file.component';
import { DanhSachTHYeuCauComponent} from './danhsach.component';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {ToastrService} from 'ngx-toastr';
import { YKienXuLyYeuCauComponent} from './ykienxl.component';
import {YeuCau} from '../../../../models/yeucau/yeucau';
import {YeuCauXuLy} from '../../../../models/yeucau/yeucauxuly';
import {YeuCauFile} from '../../../../models/yeucau/yeucaufile';
import {YeuCauComment} from '../../../../models/yeucau/yeucaucomment';
import {YeuCauService} from '../../../../service/yeucau/service-yeucau';
import {YeuCauFileService} from '../../../../service/yeucau/service-yeucaufile';
import {YeuCauXuLyService} from '../../../../service/yeucau/service-yeucauxuly';
import {YeuCauCommentService} from '../../../../service/yeucau/service-yeucaucomment';
import {ThoiHanYeuCauComponent} from './thoihan.component';
import {JoinYeuCauComponent} from './join.component';
import {ChuyenGiaoViec} from '../../../../models/yeucau/chuyengiaoviec';
import {ChuyenGiaoViecComment} from '../../../../models/yeucau/chuyengiaovieccomment';
import {ChuyenGiaoViecCommentService} from '../../../../service/yeucau/service-chuyengiaovieccomment';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  selector: 'xulyyeucau-detail',
  templateUrl: './detailyeucau.component.html',

})
export class XuLyDetailYeuCauComponent implements OnInit, AfterViewInit {
  @Input() yeuCauId: number = 0;
  @Output() backMethod: EventEmitter<string> = new EventEmitter();
  @Output() nextPage: EventEmitter<string> = new EventEmitter();
  @Output() backPage: EventEmitter<string> = new EventEmitter();
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public language = language;
  public showAction = true;
  public yeuCauItem: YeuCau = new YeuCau();
  public yeuCauXuLyItem: YeuCauXuLy = new YeuCauXuLy();
  public yeuCauFiles: YeuCauFile[] = [];
  public yeuCauXuLyList: YeuCauXuLy[] = [];
  public yeuCauXuLyUser: YeuCauXuLy[] = [];
  public yeuCauCommentList: YeuCauComment[]=[];
  public fileLists: Object[]=[];
  public urlExportYeuCau: string = environment.exportYeuCau;
  public urlPrintYeuCau: string= environment.printYeuCau;
  public trangThaiHoanThanh: number = environment.hoanthanh;
  public maNguoiXuLy: number = Sessioncommand.staffId;
  public hoanThanhList: YeuCauXuLy[] = [];
  public chuaXuLyList: YeuCauXuLy[] = [];
  public dangXuLyList: YeuCauXuLy[] = [];
  public chuyenGiaoViecItem: ChuyenGiaoViec = new ChuyenGiaoViec();
  public chuyenGiaoViecCommandList: ChuyenGiaoViecComment[] = [];
  public isOpen: boolean = false;
  public permission0025: boolean = false;
  public permission0026: boolean = false;
  constructor(
    public yeuCauService: YeuCauService,
    public datepipe: DatePipe,
    public toastr: ToastrService,
    public commandUtil: CommandUtil,
    public yeuCauFileService: YeuCauFileService,
    public yeuCauXuLyService: YeuCauXuLyService,
    public bsModalService: BsModalService,
    public yeuCauCommentService: YeuCauCommentService,
    public chuyenGiaoViecCommentService: ChuyenGiaoViecCommentService,
    public navItemService: NavItemService,
    public sanitizer: DomSanitizer
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0025', true).subscribe(
      x => { this.permission0025 = x>0 ? true: false;}
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0026', true).subscribe(
      x => { this.permission0026 = x>0 ? true: false;}
    );
    this.edit(this.yeuCauId);
  }
  public thoiHan() {
    const modalEdit = this.bsModalService.show(ThoiHanYeuCauComponent);
    (<ThoiHanYeuCauComponent>modalEdit.content).edit(
      this.yeuCauId
    );
    (<ThoiHanYeuCauComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.yeuCauId);
    });

  }

  public getXuLyById(sId: number, s: boolean): string
  {

    let xl: YeuCauXuLy = this.yeuCauXuLyList.find(x => x.maNguoiXuLy === sId);
    return xl == null ? "" : (s === true ?  xl.thoiGianXemLanDau : xl.thoiGianXemLanCuoi);

  }
  public join() {
    const modalEdit = this.bsModalService.show(JoinYeuCauComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<JoinYeuCauComponent>modalEdit.content).edit(
      this.yeuCauId
    );
    (<JoinYeuCauComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.yeuCauId);
    });

  }
  public changeStatus()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_hoanthanh_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.yeuCauXuLyService.changeStatus(this.yeuCauId, environment.hoanthanh, Sessioncommand.staffId).subscribe(
          {
            next: (data) => {
              if(data !== -1)
              {
                this.toastr.success(language.change_hoanthanh_success, language.message);
                Sessioncommand.giaiQuyetSuVuStatus = 0;
                Sessioncommand.notification = true;
              }else
                this.toastr.warning(language.error_message_success, language.message);

              this.edit(this.yeuCauId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
  public edit(id: number)
  {
    this.yeuCauId = id;
    this.yeuCauService.getById(id).subscribe(x => this.yeuCauItem = x);
    this.yeuCauXuLyService.getByMaVBAndMXL(id, Sessioncommand.staffId).subscribe(data => {
      this.yeuCauXuLyItem = data;
    });
    this.yeuCauFileService.findAllByYeuCauId(id).subscribe( x => this.yeuCauFiles = x);
    this.loadComment(this.yeuCauId);
    this.yeuCauXuLyService.findByMaYeuCau(id).subscribe( data => {this.yeuCauXuLyList = data;
      this.hoanThanhList = this.yeuCauXuLyList.filter( x => x.trangThai === environment.hoanthanh);
      this.dangXuLyList = this.yeuCauXuLyList.filter( x => x.trangThai === environment.dangxuly);
      this.chuaXuLyList = this.yeuCauXuLyList.filter( x => x.trangThai === environment.chuaxuly);
      this.yeuCauXuLyUser = this.yeuCauXuLyList.filter( x => x.maNguoiXuLy !== this.maNguoiXuLy);
    });
    this.chuyenGiaoViecCommentService.findAllByClassPK(id).subscribe( data => this.chuyenGiaoViecCommandList = data);
  }

  public showXuLy(yeuCauList: YeuCauXuLy[])
  {
    const modalEdit = this.bsModalService.show(DanhSachTHYeuCauComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DanhSachTHYeuCauComponent>modalEdit.content).edit(
      yeuCauList
    );
    (<DanhSachTHYeuCauComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public loadComment(id: number)
  {
    this.yeuCauCommentService.getCountByKeyword(id, Sessioncommand.staffId).subscribe( data => this.totalItems = data);
    this.yeuCauCommentService.findAllByPaging(id, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe( data => this.yeuCauCommentList = data);
  }
  public yKienTongHop() {
    const modalEdit = this.bsModalService.show(TongHopYKienYeuCauComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<TongHopYKienYeuCauComponent>modalEdit.content).edit(
      this.yeuCauId
    );
    (<TongHopYKienYeuCauComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }
  public yKienXuLy(replyId: number) {
    const modalEdit = this.bsModalService.show(YKienXuLyYeuCauComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<YKienXuLyYeuCauComponent>modalEdit.content).edit(
      this.yeuCauId, replyId
    );
    (<YKienXuLyYeuCauComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.yeuCauId);
    });

  }
  public thayFile(id: number) {
    const modalEdit = this.bsModalService.show(FileYeuCauComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<FileYeuCauComponent>modalEdit.content).edit(
      id
    );
    (<FileYeuCauComponent>modalEdit.content).onClose.subscribe(result => {
      this.loadComment(this.yeuCauId);
    });

  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.yeuCauId);
  }
  public xuLyLai()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.message_xulylai_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.yeuCauXuLyService.xuLyLai(this.yeuCauId, environment.chuaxuly, this.yeuCauItem.maNguoiChuTri).subscribe(
          {
            next: (data) => {
              this.toastr.success(language.message_xulylai_success, language.message);
              Sessioncommand.giaiQuyetSuVuStatus = 0;
              Sessioncommand.notification = true;
              this.edit(this.yeuCauId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }

  public thamKhao()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
    this.yeuCauItem.choThamKhao === 1? language.message_not_thamkhao_question: language.message_thamkhao_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.yeuCauService.changeThamKhao(this.yeuCauId, (this.yeuCauItem.choThamKhao === 1? 0 : 1) ).subscribe(
          {
            next: (data) => {
              this.toastr.success(this.yeuCauItem.choThamKhao === 1? language.message_not_thamkhao_success: language.message_thamkhao_success, language.message);
              this.edit(this.yeuCauId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }

}

